import { forEach, includes, keys, some, toLower } from 'lodash-es';

import { getQueryValue } from 'common/hooks/use-query-string.hook';

const isFxUrlOverrideAllowed = process.env.REACT_APP_FX_ALLOW_URL_FEATUREFLAG_OVERRIDE === 'true';

let backendFxIntegrationValue: boolean | null = null; // Rework to use hooks

export const FEATURE_FLAG_URL_PREFIX = 'ff_';

export type FeatureFlag =
    | 'editDataCollectionDate'
    | 'editVisitDate'
    | 'printSiteFooter'
    | 'editTranscription'
    | 'sso'
    | 'okta'
    | 'tableauCustomReports'
    | 'tableauStandardReports'
    | 'fxIntegration' // Deprecated - always true
    | 'patientHistory'
    | 'connectorApp';

// Flags that can be controlled via URL parameters
export const urlQueryParamFlags: FeatureFlag[] = ['fxIntegration', 'connectorApp'];

type FeatureFlagsType = Record<FeatureFlag, boolean>;

export const defaultFlags: FeatureFlagsType = {
    editDataCollectionDate: false,
    editVisitDate: false,
    printSiteFooter: false,
    editTranscription: false,
    // SSO
    sso: true,
    okta: true,
    // Native Site App
    patientHistory: true,
    // Reporting
    tableauCustomReports: true,
    tableauStandardReports: true,
    // Fx/Lx integration
    fxIntegration: true, // BE initialized - Deprecated - always true
    connectorApp: false,
};

export function createFeatureFlags(): FeatureFlagsType {
    const flags = { ...defaultFlags };

    // Apply URL parameter overrides
    forEach(keys(flags), (flag) => {
        if (includes(urlQueryParamFlags, flag as FeatureFlag)) {
            if (flag === 'fxIntegration' && !isFxUrlOverrideEnabled()) {
                return;
            }

            const paramValue =
                getQueryValue(`${FEATURE_FLAG_URL_PREFIX}${flag}`) ||
                getQueryValue(toLower(`${FEATURE_FLAG_URL_PREFIX}${flag}`));
            if (paramValue === 'true') {
                flags[flag as FeatureFlag] = true;
            } else if (paramValue === 'false') {
                flags[flag as FeatureFlag] = false;
            }
        }
    });

    return flags;
}

export const featureFlags = createFeatureFlags();

export function isFeatureEnabled(featureFlag: FeatureFlag): boolean {
    return featureFlags[featureFlag] || false;
}

export function areAnyFeaturesEnabled(...flags: FeatureFlag[]): boolean {
    return some(flags, (flag) => isFeatureEnabled(flag));
}

export function isUrlQueryParamFlag(key: string): boolean {
    return some(urlQueryParamFlags, (flag) => toLower(key) === toLower(`${FEATURE_FLAG_URL_PREFIX}${flag}`));
}

export function isFxUrlOverrideEnabled(): boolean {
    // If backend explicitly disabled fxIntegration, don't allow URL override
    if (backendFxIntegrationValue === false) {
        return false;
    }

    return isFxUrlOverrideAllowed;
}

export function setBackendFxIntegrationEnabled(enabled: boolean): void {
    backendFxIntegrationValue = enabled;
    defaultFlags.fxIntegration = enabled;

    if (!enabled) {
        featureFlags.fxIntegration = false;
    }
}

export const FEATURE_FLAGS_STORAGE_KEY = 'ciFeatureFlags';
